export interface Partnership {
  createdAt: string
  id: number
  description: string
  metadata: object
  name: string
  permalink: string
  state: 'active' | 'inactive'
  updatedAt: string
}

export default function PartnershipsPage({ partnerships }: { partnerships: Partnership[] }) {
  return (
    <div className="tw-flex tw-w-full tw-flex-col">
      <div id="page-header" className="tw-flex tw-justify-between">
        <h4>Partnerships</h4>
        {`Showing ${partnerships.length} out of ${partnerships.length} partnerships`}
      </div>
      <div className="tw-container tw-px-3">
        <div className="tw-block tw-w-full tw-overflow-x-auto tw-rounded-lg tw-bg-white tw-shadow-md">
          <table className="tw-w-full">
            <TableHeader />
            <tbody>
              {partnerships.map((partnership) => (
                <tr key={partnership.id} className="even:tw-bg-neutral-50">
                  <td className="tw-border-0 tw-border-t tw-border-solid tw-border-t-neutral-200 tw-p-4 tw-align-bottom">
                    {partnership.name}
                  </td>
                  <td className="tw-border-0 tw-border-t tw-border-solid tw-border-t-neutral-200 tw-p-4 tw-align-bottom">
                    {partnership.permalink}
                  </td>
                  <td className="tw-border-0 tw-border-t tw-border-solid tw-border-t-neutral-200 tw-p-4 tw-align-bottom">
                    {partnership.description}
                  </td>
                  <td className="tw-border-0 tw-border-t tw-border-solid tw-border-t-neutral-200 tw-p-4 tw-align-bottom">
                    {partnership.state}
                  </td>
                  <td className="tw-border-0 tw-border-t tw-border-solid tw-border-t-neutral-200 tw-p-4 tw-align-bottom">
                    {JSON.stringify(partnership.metadata)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

function TableHeader() {
  const headerClass =
    'tw-cursor-pointer tw-border-0 tw-border-b tw-border-solid tw-border-b-neutral-200 tw-p-4 tw-align-bottom'

  return (
    <thead>
      <tr>
        <th className={headerClass}>Name</th>
        <th className={headerClass}>Permalink</th>
        <th className={headerClass}>Description</th>
        <th className={headerClass}>State</th>
        <th className={headerClass}>Metadata</th>
      </tr>
    </thead>
  )
}
